<template>
  <div class="flex gap-2">
    <VaIconHideSidebar
      class="cursor-pointer"
      :class="{ 'x-flip': !isSidebarMinimized }"
      :color="collapseIconColor"
      @click="isSidebarMinimized = !isSidebarMinimized"
    />

    <nav class="flex items-center">
      <VaBreadcrumbs>
        <VaBreadcrumbsItem
          v-for="item in items"
          :key="item.label"
          :label="item.label"
          class="text-xs"
          @click="handleBreadcrumbClick(item)"
        />
      </VaBreadcrumbs>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useGlobalStore } from '../../stores/global-store'
import { storeToRefs } from 'pinia'
import { useColors } from 'vuestic-ui/web-components'
import VaIconHideSidebar from '../icons/VaIconHideSidebar.vue'

const { isSidebarMinimized } = storeToRefs(useGlobalStore())
const { getColor } = useColors()
const collapseIconColor = computed(() => getColor('secondary'))

const router = useRouter()
const route = useRoute()

type BreadcrumbNavigationItem = {
  label: string
  to: string
  hasChildren: boolean
}

const items = computed(() => {
  const result: { label: any; to: string; hasChildren: boolean }[] = []
  route.matched.forEach((route) => {
    result.push({
      label: route.name,
      to: route.path,
      hasChildren: route.children && route.children.length > 0,
    })
  })
  return result
})

const handleBreadcrumbClick = (item: BreadcrumbNavigationItem) => {
  if (!item.hasChildren) {
    router.push(item.to)
  }
}
</script>

<style lang="scss" scoped>
.x-flip {
  transform: scaleX(-100%);
}
</style>
